module.exports = __webpack_public_path__ + "img/logo.7c502a95.png";